import React from 'react';

import { Input as AntdInput, InputProps as AntdInputProps } from 'antd';

import { FormPlaceholders } from 'types/enums/FormPlaceholders';

export default function BaseInputNumber(
  props: AntdInputProps,
): React.ReactElement {
  return (
    <AntdInput
      {...props}
      type={'number'}
      placeholder={props.placeholder ?? FormPlaceholders.Number}
    />
  );
}
